import { render } from "./AllPatientReports.vue?vue&type=template&id=26ef1ae7"
import script from "./AllPatientReports.vue?vue&type=script&lang=js"
export * from "./AllPatientReports.vue?vue&type=script&lang=js"

import "./AllPatientReports.vue?vue&type=style&index=0&id=26ef1ae7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__